import { render, staticRenderFns } from "./diseno-moldes.vue?vue&type=template&id=8e3423ec&lang=html"
import script from "./diseno-moldes.vue?vue&type=script&lang=js"
export * from "./diseno-moldes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports